<div
  style="
    background-color: var(--colorPageBackground);
    padding: 20px;
    border-radius: 10px;
    filter: drop-shadow(3px 3px #efefef);
  "
>
  <h4>Invoice Number</h4>
  <div style="display: flex; align-items: center">
    <div
      style="width: 20%; display: flex; align-items: center; margin-top: 10px"
    >
      <input type="number" [(ngModel)]="invoiceNumber" />
    </div>
  </div>
  <div style="width: 20%; display: flex; align-items: center; margin-top: 20px">
    <input
      type="button"
      value="Next"
      class="button_secondary button_var_2"
      (click)="save()"
    />
  </div>
</div>
